var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlamingo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2 79.7s-.1-8 9.2-17.5l5.8-7.3 5.9-10.3v-2.9l-2.9-.6-4.7-1.1-1.7 4.4-1.1 7.5-2.1 1.6-2.5-1.4s-3.5-7-3.4-7.9c.1-.9.5-5.6.5-5.6l1.8-4 3.2-3.7s1-6 10-7.2c9-1.2 14.5 4.8 14.5 4.8l1.4 3.4.6 6.3-.6 5.6-3.1 8.7-3.1 6.4s-.8 2 .4 3.3c0 0 13.2 1.1 20.5 5L75.9 77l-44.7 2.7z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7 40.1s7.4-.3 9.1 4.4l-.5 3-.7 4.5-2.1 1.6-2.5-1.4-2.9-6.3-.4-5.8z",
    fill: "#5D21D2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3 62.4c4.9.2 9.9 1.1 15.1 2.8 19.4 6.4 31.9 21.5 27.9 33.7-4 12.2-23 16.9-42.5 10.5C40.5 102.9 28 87.8 32 75.6",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3 62.4c4.9.2 9.9 1.1 15.1 2.8 19.4 6.4 31.9 21.5 27.9 33.7-4 12.2-23 16.9-42.5 10.5C40.5 102.9 28 87.8 32 75.6",
    stroke: "#311D6C",
    strokeWidth: 1.879,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6 40.1s2.9 1 6.8 1.3c3.9.3-3.2 11.7-10.1 19.9-6.9 8.2-7.9 10.6-9.3 14.4M39.2 30.8s1.5-7.5 12.9-7.3c0 0 11.3-.1 12.9 8.3",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6 31.6s-10.3 8-.9 21.3c0 0 4.2 2.9 4.5-3.9.3-6.8 2.3-9 2.3-9s4.6-9-5.9-8.4z",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3 73.4c-8.5-5.2-18.6-6.3-27.8-3.8.9-2.2 2.1-4.4 3.2-6.6-3.7-1.6-3.7-7.5-.1-9.2 2.4-4.3 4.3-9.3 4-14.3-.1-1.1.2-2.1.7-2.8-2.2-5.6-6.9-9.9-13.9-10.5-6.4-.6-6.4 9.4 0 10 3.9.4 5.6 5 5.6 8.3-.1 4.9-2.7 9.4-5 13.6-3 5.5-5.7 11-6.5 17.1-.7.5-1.4 1-2 1.5-3.6 2.9-.9 7.3 2.7 8.1C50.9 98.6 64.8 107.2 79 104c6.6-1.5 14.2-6 16.5-12.7 2.8-7.8-3.1-14.1-9.2-17.9zm-2.7 17.4c-2.2 1.9-5.1 3.1-8 3.6-6.2 1.1-12.4-1.3-16.1-6.5-1.8-2.5-2.7-4.9-3-7.3 8.7-3.9 19.8-3.1 27.1 3.1 3.1 2.6 3.1 4.5 0 7.1z",
    fill: "#FFCBBD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2 32.6a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2z",
    fill: "#311D6C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 81.5s15.2-3.6 23.4 7M54 79.7s8.6 14.4 30.5 7.4M65.6 36.6s.3 9.7-5.4 19.2M58.8 58.9s-.7 1.7.4 3.3",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3 62.4c4.9.2 9.9 1.1 15.1 2.8 19.4 6.4 31.9 21.5 27.9 33.7-4 12.2-23 16.9-42.5 10.5C40.5 102.9 28 87.8 32 75.6",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlamingo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flamingo.a2dafe4febc1f67d33b41e7a7fac4934.svg";